/**
 * Cdn Type Formatter.
 * @param {string} value
 * @returns {string}
 */
window.cdnTypeFormatter = function(value) {
    if (value === 'directory') {
        return '<i class="fa fa-folder text-warning"></i>';
    }
    return '<i class="fa fa-file text-secondary"></i>';
};
